export const activeEffect = `:active {
   box-shadow: 0 0 5px 0 gray;
}`;

export const activeEffectBackgroundColor = `:active {
   background-color: rgba(0, 0, 0, 0.1);
   transition: all 0.2s;
}`;
